import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgBankCard = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.26 6.5H3.74a.245.245 0 0 0-.24.25v1.5h17v-1.5a.245.245 0 0 0-.24-.25M3.5 14.25v-1.5H11a.75.75 0 0 0 0-1.5H3.5v-1.5h17v1.5H17a.75.75 0 0 0 0 1.5h3.5v4.5c0 .147-.116.25-.24.25H3.74a.245.245 0 0 1-.24-.25v-1.5H7a.75.75 0 0 0 0-1.5zM3.74 5h16.52c.961 0 1.74.784 1.74 1.75v10.5c0 .966-.779 1.75-1.74 1.75H3.74C2.778 19 2 18.216 2 17.25V6.75C2 5.784 2.779 5 3.74 5"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgBankCard;
